module.exports = __webpack_public_path__ + "img/an-african-american-student.307dfd48.png";